(function () {
  angular.module("akitabox.ui.dialogs.bulkDelete.asset", [
    "akitabox.core.constants",
    "akitabox.core.toast",
    "akitabox.core.services.asset",
    "akitabox.core.services.flag",
    "akitabox.core.services.organization",
  ]);
})();
